<template>
    <div class="container">
        <div class="mt-4 mb-4 text-center">
            <h1>{{ subject.title }}</h1>
            <p>Carte Trello associéee : <a :href='"https://trello.com/c/" + card.id' target="_blank">{{ card.name }}</a></p>
            <p>Titre du podcast : {{ subject.titlePodcast ? subject.titlePodcast : 'non définit'}}</p>
            <p :style="{ backgroundColor: statut.color}">Statut : {{statut.name}}</p>
            <!--<p class="btn btn-warning">Statut : Booking En Cours</p>-->
            <b-alert v-if="errorMessages.length > 0" variant="danger" show>
                <p v-for="errorMessage in errorMessages">{{ errorMessage }}</p>
            </b-alert>
            <b-alert v-if="successMessage" variant="success" show>{{ successMessage }}</b-alert>
        </div>
        <b-tabs v-if="subjectFound && cardFound">
            <b-tab title="Résumé" active class="mt-4 mb-4">
                <resume-form v-bind:subject="subject" v-bind:editPending="editPending" v-on:push-edit="pushEdit"
                             v-on:push-section="pushSectionDatas"
                             v-on:update-labels="updateTrelloLabelsForBoard"></resume-form>
            </b-tab>
            <b-tab title="Booking" class="mt-4 mb-4">
                <booking-form v-bind:subject="subject" v-bind:editPending="editPending" v-on:push-edit="pushEdit"
                              v-on:push-section="pushSectionDatas"></booking-form>
            </b-tab>
            <b-tab title="Diffusion" class="mt-4 mb-4">
                <diffusion-form v-bind:subject="subject" v-bind:editPending="editPending" v-on:push-edit="pushEdit"
                                v-on:push-section="pushSectionDatas"></diffusion-form>
            </b-tab>
            <b-tab title="Podcast" class="mt-4 mb-4">
                <podcast-form v-bind:subject="subject" v-bind:editPending="editPending" v-on:push-edit="pushEdit"
                              v-on:push-section="pushSectionDatas"></podcast-form>
            </b-tab>
            <b-tab title="Publication" class="mt-4 mb-4">
                <publication-form v-bind:subject="subject" v-bind:statut="statut" v-bind:editPending="editPending"
                                  v-on:publish="publish"></publication-form>
            </b-tab>
            <b-tab title="Édition avancée" class="mt-4 mb-4">
                <advanced-form v-bind:subject="subject" v-bind:statut="statut" v-bind:editPending="editPending"
                               v-on:push-edit="pushEdit"
                               v-on:push-section="pushSectionDatas"></advanced-form>
            </b-tab>
            <b-tab title="Infos" clss="mt-4 mb-4">
              <form class="mt-4">
                <fieldset class="form-group">
                  <legend>Description actuelle de la carte</legend>
                  <textarea readonly class="form-control">{{ card.desc }}</textarea>
                </fieldset>
              </form>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>

  import bdd from "../api/bdd"
  import utils from "../utils/utils"
  import ResumeForm from "./EditSub/ResumeForm"
  import BookingForm from "./EditSub/BookingForm"
  import DiffusionForm from "./EditSub/DiffusionForm"
  import PodcastForm from "./EditSub/PodcastForm"
  import PublicationForm from "./EditSub/PublicationForm"
  import AdvancedForm from "./EditSub/AdvancedForm"

  export default {

    name: 'Edit',

    components: {
      AdvancedForm,
      BookingForm,
      ResumeForm,
      DiffusionForm,
      PodcastForm,
      PublicationForm
    },

    data() {
      return {
        card: {
          id: '',
          name: 'carte non trouvée'
        },
        errorMessages: [],
        successMessage: '',
        subject: {
          id: this.$route.params.id,
          resume: '',
          format: ''
        },
        subjectFound: false,
        cardFound: false,
        allSectionsDatas: {},
        availableLabels: [],
        awaitingLabels: [],
        statut: {
          name: 'en attente',
          color: ''
        },
        availableStatuts: [],
        editPending: false
      }
    },

    mounted() {
      /**
       * lorsque le composant est monté on cherche à se connecter avec Trello
       * si tout bon on lance la récupération du sujet
       *
       */
      window.Trello.authorize({
        type: 'popup',
        name: 'Vostok Subjects Manager',
        scope: {
          read: 'true',
          write: 'true'
        },
        expiration: 'never',
        success: this.getSubjectAndCard,
        error: this.trelloError
      })

    },

    methods: {

      /**
       * récupérer le sujet via la bdd et lancer la récupération de la carte Trello
       *
       */
      getSubjectAndCard: function () {
        bdd.getSubject(this.subject.id)
          .then(response => {
            this.subject = response.data
            this.subjectFound = true
            console.log('sujet récupéré :', this.subject)
            window.Trello.get('/cards/' + response.data.trelloCardId, this.getCardSuccess, this.trelloError)
          })
          .catch(error => {
            this.errorMessages.push('sujet non trouvé')
            console.log(error.message)
          })
      },

      /**
       * mise à jour de la carte Trello lorsqu'elle est récupérée avec succès
       *
       * @param data
       */
      getCardSuccess: function (data) {
        this.card = data
        this.cardFound = true
        console.log('carte récupérée', data)
        // on récupère le statut
        this.getStatut()
      },

      getStatut: function () {
        // on commence par récupérer les statuts disponibles
        bdd.getAvailableLabel('statuts')
          .then(statuts => {
            this.availableStatuts = statuts
            console.log('statuts disponibles : ', this.availableStatuts)
            // on met à jour les labels Trello
            this.updateTrelloLabelsForBoard(statuts)
            // et on met à jour le statut actuel
            // si un statut courant existe on le met à jour
            if (this.subject.statut !== null) {
              this.setStatut()
            } else {
              this.statut = {
                name: 'en attente',
                color: ''
              }
            }
          })
          .catch(error => {
            this.errorMessages.push('impossible de récupérer les statuts : ' + error.message)
            console.log(error)
          })
      },

      setStatut: function () {
        // on prépare notre ID de statut pour la comparaison (car on la veux sans le préfixe de l'API
        let index = this.subject.statut.lastIndexOf('/') + 1
        let statutCleanId = this.subject.statut.substr(index)
        for (let i = 0; i < this.availableStatuts.length; i++) {
          if (statutCleanId === this.availableStatuts[i].id) {
            this.statut.name = this.availableStatuts[i].name
            this.statut.color = this.availableStatuts[i].color
          }
        }
      },

      /**
       * lors d'une erreur Trello
       *
       * @param e
       */
      trelloError: function (e) {
        this.errorMessages.push('erreur API Trello : ' + e.responseText)
        console.log('erreur API Trello !', e)
      },

      /**
       * appelée par les composants, lorsqu'une section est montée --> push-section
       * on met alors à jour les informations de la section dans notre objet allSectionsDatas
       *
       * @param sectionDatas
       * @param section
       */
      pushSectionDatas: function (sectionDatas, section) {
        this.allSectionsDatas[section] = sectionDatas
        console.log('push en cours')
      },

      /**
       * appelée par les composants, lorsqu'une section est mise à jour --> push-edit
       * on met alors à jour les informations du sujet en bdd puis la carte Trello
       *
       * @param sectionDatas
       * @param section
       */
      pushEdit: function (sectionDatas, section) {
        // on indique le statut d'édition en cours pour les composants
        this.editPending = true
        // on assemble les données de toutes les section avec les données de la section à mettre à jour
        this.allSectionsDatas[section] = sectionDatas
        let allSectionsDatas = {}
        for (let sectionDatas in this.allSectionsDatas) {
          for (let elem in this.allSectionsDatas[sectionDatas]) {
            allSectionsDatas[elem] = this.allSectionsDatas[sectionDatas][elem]
          }
        }
        // on vide la section publication pour éviter les doubles publication
        delete this.allSectionsDatas['publication']
        // on commence par essayer de persister les données
        bdd.persistSection(this.subject.id, allSectionsDatas)
          .then(subject => {
            // si OK on met à jour le sujet
            this.subject = subject
            // et le statut
            if (this.subject.statut !== null) {
              this.setStatut()
            }
          })
          .catch(error => {
            this.errorMessages.push('erreur BDD : ' + error.message)
            console.log(error)
            this.editPending = false
          })
          .then(() => {
            // si OK on prépare les params de la carte avec le sujet mis à jour + nos infos de sections
            let params = this.formatTrelloDatas(this.subject, allSectionsDatas)
            // mise à jour de la carte
            window.Trello.put('/cards/' + this.card.id, params, this.pushEditSuccess, this.trelloError)
            console.log('mise à jour bdd effectuée')
          })
          .catch(error => {
            this.errorMessages.push('erreur préparation carte : ' + error.message)
            console.log(error)
            this.editPending = false
          })
      },

      /**
       * prépare et formatte les informations pour mettre à jour la carte Trello
       * les renvoie dans un objet prêt à être utilisé par l'API Trello
       *
       */
      formatTrelloDatas: function (subject, allSectionsDatas) {
        // le lien d'édition de la carte
        let cardEditLink = process.env.CLIENT_URL + '/#/edit/' + this.subject.id
        // on formatte le titre de la carte via l'utilitaire
        let cardTitle = utils.formatCardTitle(subject, allSectionsDatas, this.card.name)
        // on formatte la description de la carte via l'utilitaire
        let descSections = utils.formatCardDescription(subject, allSectionsDatas)
        // tableau pour stocker les différents labels
        let arrayLabels = []
        // on récupère le label correspondant au format du sujet
        let idFormatLabel = ''
        if (subject.format !== null && subject.format !== '') {
          let label = this.availableLabels.filter(item => item.name === allSectionsDatas.format.datas.name)
          idFormatLabel = label[0].id
          arrayLabels.push(idFormatLabel)
        }
        // on récupère le label correspondant à la rubrique du sujet
        let idRubriqueLabel = ''
        if (subject.rubrique !== null && subject.rubrique !== '') {
          let label = this.availableLabels.filter(item => item.name === allSectionsDatas.rubrique.datas.name)
          idRubriqueLabel = label[0].id
          arrayLabels.push(idRubriqueLabel)
        }
        // on récupère le label de statut
        let idStatutLabel = ''
        if (this.statut !== null && this.statut.name !== 'en attente') {
          let label = this.availableLabels.filter(item => item.name === this.statut.name)
          if (label.length > 0) {
            idStatutLabel = label[0].id
            arrayLabels.push(idStatutLabel)
          }
        }
        // log
        console.log('description de la carte :', descSections)
        console.log('titre de la carte :', cardTitle)
        // lien d'édition formatté pour la description
        let descLink = '### Lien pour éditer cette carte : \x0A [' + cardEditLink + '](' + cardEditLink + ') \x0A \x0A --- \x0A'
        // les nouvelles données de la carte sont renvoyées
        return {
          name: cardTitle,
          desc: descLink + descSections,
          idLabels: arrayLabels
        }
      },

      /** fonction de succès lors d'une mise à jour de carte
       *
       */
      pushEditSuccess: function () {
        this.successMessage = 'carte mise à jour'
        setTimeout(() => this.successMessage = '', 3000)// pour effacer le message au bout de 3 sec
        console.log('edit effectué')
        console.log('carte mise à jour')
        this.editPending = false
        this.getSubjectAndCard() // afin de mettre à jour les informations affichées (provoque un appel supplémentaire aux API)
      },

      /**
       * pour la mise à jour du titre du sujet
       *
       * @param e
       */
      pushTitle: function (e) {
        e.preventDefault()
        let sectionDatas = {
          title: {
            name: 'title',
            datas: this.subject.title
          }
        }
        bdd.persistSection(this.subject.id, sectionDatas)
          .then(subject => {
            // on formatte le titre avant de l'enregistrer côté Trello
            // pour cela on a besoin de l'ensemble des données de section
            let allSectionsDatas = {}
            for (let sectionDatas in this.allSectionsDatas) {
              for (let elem in this.allSectionsDatas[sectionDatas]) {
                allSectionsDatas[elem] = this.allSectionsDatas[sectionDatas][elem]
              }
            }
            let trelloTitle = utils.formatCardTitle(this.subject, allSectionsDatas, this.card.name)
            window.Trello.put('/cards/' + this.card.id, {name: trelloTitle}, this.pushEditSuccess, this.trelloError)
          })
          .catch(error => {
            this.errorMessages.push(error.message)
            console.log(error)
          })
      },

      /**
       * vérifie que les labels passés en paramètre existent sur le board contenant la carte
       * lance la création de nouveaux labels au besoin
       * et stocke les ID et noms des labels disponibles
       * peut être appelé par les composants --> update-labels
       *
       * les fonctions ci dessous se succèdent pour ces opérations (à cause des call back Trello)
       *
       * @param labels
       */
      updateTrelloLabelsForBoard: function (labels) {
        this.awaitingLabels = labels
        // on récupère les labels disponible sur le board de la card
        window.Trello.get(
          '/boards/' + this.card.idBoard + '/labels',
          this.compareAvailableLabels,
          this.trelloError
        )
      },
      compareAvailableLabels: function (data) {
        this.availableLabels = data
        console.log('update label, labels disponibles : ', this.availableLabels)
        let availableNames = this.availableLabels.map(item => {
          return item["name"]
        })
        let labels = this.awaitingLabels
        // on compare avec les label à mettre à jour
        for (let i = 0; i < labels.length; i++) {
          if (availableNames.indexOf(labels[i].name) === -1) {
            this.createTrelloLabelForBoard(labels[i])
          }
        }
      },
      createTrelloLabelForBoard: function (label) {
        let params = {
          name: label.name,
          color: label.color,
          idBoard: this.card.idBoard
        }
        window.Trello.post(
          '/labels',
          params,
          this.updateLabelList,
          this.trelloError
        )
      },
      updateLabelList: function (data) {
        this.availableLabels.push(data)
        console.log('creation nouveau label pour ' + data.name)
      },

      /**
       *
       * déclenche la publication du podcast
       *
       */
      publish: function () {
        // on enverra le parametre aPublier pour le sujet, c'est cela qui déclenchera la publication côté backend
        let sectionDatas = {
          aPublier: {
            name: 'aPublier',
            datas: 'true'
          }
        }
        // la fonction habituelle de persistance
        this.pushEdit(sectionDatas, 'publication')
      }

    }

  }

</script>



// WEBPACK FOOTER //
// src/components/Edit.vue